<div class="attachments-container" [class.collapsed]="isCollapsed" [class.drag-over]="isDragging" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
    <!-- Improved header section with title and add button -->
    <div class="attachments-header" (click)="toggleCollapse()">
        <div class="header-content">
            <mat-icon>attach_file</mat-icon>
            <span>Attachments</span>
            <span class="attachment-count" *ngIf="attachments && attachments.length > 0">({{ attachments.length }})</span>
        </div>
        <div class="header-actions">
            <button 
                type="button" 
                class="add-button" 
                matTooltip="Add attachment"
                (click)="openFileDialog($event)">
                <mat-icon>add</mat-icon>
            </button>
            <button 
                type="button" 
                class="toggle-button" 
                [matTooltip]="isCollapsed ? 'Expand' : 'Collapse'"
                (click)="$event.stopPropagation(); toggleCollapse()">
                <mat-icon>{{ isCollapsed ? 'expand_more' : 'expand_less' }}</mat-icon>
            </button>
        </div>
    </div>
    
    <!-- Content section (conditionally shown based on collapsed state) -->
    <div class="attachments-content" [class.hidden]="isCollapsed">
        <!-- Hidden file input -->
        <input 
            type="file" 
            #fileInput 
            style="display: none;" 
            (change)="selectFile($event)"
        >
        
        <!-- Files section -->
        <div class="files">
            <div class="files-inner">
                <!-- All files (both uploading and completed) -->
                @if (attachments && attachments.length > 0) {
                    @for (file of attachments; track file) {
                    <div class="file" [class.file-uploading]="isFileUpload(file)">
                        @if (getFileDetails(file) | async; as fileDetails) {
                        <div class="file-inner">
                            <!-- Delete button -->
                            <button type="button" 
                                    class="delete" 
                                    appConfirm="Do you really want to delete this file?"
                                    (confirm)="deleteFile(file)"
                                    matTooltip="Delete file">
                                <mat-icon>close</mat-icon>
                            </button>
                            
                            <!-- File preview -->
                            <div class="file-preview">
                                @if (fileDetails.image && !fileDetails.isUploading) {
                                    <img [src]="file" [alt]="fileDetails.filename" />
                                } @else {
                                    <div class="file-icon-wrapper">
                                        <mat-icon class="file-type-icon">{{ fileDetails.icon }}</mat-icon>
                                    </div>
                                }
                            </div>
                            
                            <!-- File name -->
                            @if (fileDetails.isUploading) {
                                <div class="name uploading">
                                    <div class="file-name-text">{{ getFileName(file) }}</div>
                                    <div class="progress-container">
                                        <div class="progress-bar">
                                            <div class="progress-fill" [style.width.%]="getFileUploadPercentage(file) || 1"></div>
                                        </div>
                                        <div class="progress-text">{{ getFileUploadPercentage(file) || 0 }}%</div>
                                    </div>
                                </div>
                            } @else {
                                <div class="name" [title]="fileDetails.filename">
                                    {{ fileDetails.filename }}
                                </div>
                                
                                <!-- File link (invisible, covers the whole card) -->
                                <a [href]="file" target="_blank" class="file-link" matTooltip="Open file"></a>
                            }
                        </div>
                        }
                    </div>
                    }
                } 
                
                <!-- Empty state with upload area -->
                @if (!attachments || attachments.length === 0) {
                    <div class="upload-area">
                        <div class="upload-content">
                            <mat-icon>cloud_upload</mat-icon>
                            <p>Drag files here or click to upload</p>
                            <button 
                                type="button" 
                                class="upload-button" 
                                (click)="openFileDialog($event)">
                                <mat-icon>add</mat-icon>
                                <span>Select Files</span>
                            </button>
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>
</div>

<!-- <app-section-image [imageUrl]="selectedPage?.file"  *ngIf="boardForm.value.section" [section]="boardForm.value.section" ></app-section-image> -->